import { render, staticRenderFns } from "./Bubble.vue?vue&type=template&id=752413e0&scoped=true"
import script from "./Bubble.vue?vue&type=script&lang=js"
export * from "./Bubble.vue?vue&type=script&lang=js"
import style0 from "./Bubble.vue?vue&type=style&index=0&id=752413e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752413e0",
  null
  
)

export default component.exports